export default "__VITE_ASSET__a867bbc0__"